import { motion } from "framer-motion";

export const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 z-[100] bg-[#050505] flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        className="text-center"
      >
        {/* VV Logo Animation */}
        <motion.div
          animate={{ 
            scale: [1, 1.05, 1],
            opacity: [0.8, 1, 0.8]
          }}
          transition={{ 
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="mb-8"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_auto-paint-brisbane/artifacts/37p3il2l_Screenshot%202025-04-27%20024102.png"
            alt="Velocity Paint and Panel"
            className="h-20 w-auto mx-auto"
          />
        </motion.div>

        {/* Loading text */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          <h2 className="font-heading text-xl uppercase tracking-[0.3em] text-white mb-4">
            Velocity Paint & Panel
          </h2>
          
          {/* Loading bar */}
          <div className="w-48 h-[2px] bg-white/10 mx-auto overflow-hidden">
            <motion.div
              animate={{ x: ["-100%", "100%"] }}
              transition={{ duration: 1, repeat: Infinity, ease: "easeInOut" }}
              className="w-full h-full bg-[#3b82f6]"
            />
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default LoadingScreen;
